import React from 'react';
import { Link } from 'react-router-dom';
import { BookOpen, ArrowRight, FileText, TrendingUp, Shield } from 'lucide-react';

const Guides = () => {
  const guideTopics = [
    {
      icon: FileText,
      title: 'Comment parier en ligne en France',
      description: 'Guide complet pour débuter : création de compte, dépôt, choix des paris et retrait des gains.',
    },
    {
      icon: TrendingUp,
      title: 'Stratégies de paris sportifs',
      description: 'Techniques éprouvées pour améliorer vos chances et gérer votre bankroll efficacement.',
    },
    {
      icon: Shield,
      title: 'Sécurité et réglementation',
      description: 'Tout savoir sur la légalité des paris en ligne en France et comment protéger vos données.',
    },
  ];

  return (
    <section id="guides" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <div className="inline-flex items-center justify-center w-16 h-16 bg-primary-red/10 rounded-full mb-6">
            <BookOpen className="text-primary-red" size={32} />
          </div>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Guides pratiques
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Tout ce que vous devez savoir pour parier en ligne en France en toute sérénité
          </p>
        </div>

        <div className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-8 md:p-12 mb-12">
          <div className="max-w-3xl mx-auto">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">
              Comment parier en ligne en France : le guide complet
            </h3>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              Parier en ligne en France est légal et réglementé depuis 2010. Pour commencer, choisissez une plateforme 
              agréée par l'ANJ (Autorité Nationale des Jeux), créez votre compte en quelques minutes, et effectuez votre 
              premier dépôt pour bénéficier des bonus de bienvenue.
            </p>
            <p className="text-lg text-gray-700 mb-8 leading-relaxed">
              Les sites de paris français offrent une large gamme d'événements sportifs : football, tennis, basket, 
              mais aussi e-sport et paris en direct. Chaque plateforme propose ses propres cotes et promotions, d'où 
              l'importance de comparer avant de s'engager.
            </p>
            <Link
              to="/guides"
              data-discover="true"
              className="inline-flex items-center text-primary-red font-semibold hover:text-primary-red-dark transition-colors"
            >
              Lire le guide complet
              <ArrowRight className="ml-2" size={20} />
            </Link>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8">
          {guideTopics.map((topic, index) => {
            const Icon = topic.icon;
            return (
              <div
                key={index}
                className="bg-white border-2 border-gray-100 rounded-xl p-6 hover:border-primary-red transition-colors hover:shadow-lg"
              >
                <div className="bg-primary-red/10 w-12 h-12 rounded-lg flex items-center justify-center mb-4">
                  <Icon className="text-primary-red" size={24} />
                </div>
                <h4 className="text-xl font-bold text-gray-900 mb-3">{topic.title}</h4>
                <p className="text-gray-600 mb-4 leading-relaxed">{topic.description}</p>
                <Link
                  to="/guides"
                  data-discover="true"
                  className="inline-flex items-center text-primary-red font-semibold text-sm hover:text-primary-red-dark transition-colors"
                >
                  En savoir plus
                  <ArrowRight className="ml-1" size={16} />
                </Link>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Guides;

